import React, { Component, Fragment } from 'react';
import Modal from 'react-modal';
import { Icon } from '../../Common/Icon';
import { translate } from 'react-i18next';
import cx from '../../../styles';

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
if (typeof window != 'undefined') {
    Modal.setAppElement('#root');
}

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

class TapNewUserModal extends Component {

    constructor(props) {
        super(props);
        this.state = { isOpen: false };
    }

    openModal = () => {
        this.setState({ isOpen: true });
    }

    closeModal = () => {
        this.setState({ isOpen: false });
    }

    onModalOpen = () => {
        this.setState({ isOpen: true });
    }

    onModalClose = () => {
        this.props.onModalClose();
        this.setState({ isOpen: false });
    }

    render() {
        const t = this.props.t;

        return (
            <Fragment>
                <Modal isOpen={this.props.isModalOpen}
                    onAfterOpen={this.onModalOpen}
                    onRequestClose={this.onModalClose}
                    overlayClassName="myOverlayClass tap-new-user-overlay"
                    style={customStyles} >

                    <div className={cx("tap-new-user-modal")}>
                        <div className={cx("continue-browsing")}>
                            <div onClick={() => this.onModalClose()}>
                                <span>{t('onboarding_popup_explore_community')}</span>
                                <Icon name="chevron-right-regular-md" color="#fff" />
                            </div>
                        </div>

                        <div className={cx("separator")}><span>or</span></div>

                        <div className={cx("go-back")}>
                            <a href={this.props.url} onClick={(e) => { e.preventDefault(); this.props.onTapRedirectClick() }}>
                                <Icon name="chevron-left-regular-md" />
                                <span>{t('onboarding_popup_go_back')}</span>
                            </a>
                        </div>
                    </div>
                </Modal>
            </Fragment>
        );
    }
}

export default translate()(TapNewUserModal);
